import "./Education.css"

export default function Education(){
  return <section className="education">
    <h3 className="education-header">EDUCATION</h3>
    <div className="education-one">
    <h5 className="header-5">Light House Labs - January, 2021</h5>
    <h5 className="header-5"><strong>Diploma in Web Development</strong></h5>
    </div>
    <div className="education-two">
    <h5 className="header-5">Jawaharlal Nehru Institute of Technology(India) - June, 2014</h5>
    <h5 className="header-5"><strong>Bachelors in Computer Science</strong></h5>
    </div>
  </section>
}  
